module.exports = __webpack_public_path__ + "img/ground.98d3f418.png";